<template>
<div :style="{ 'max-height': '20px' }">
  <div
    class="header-cell"
    :class="item.Id"
    @click="clicked"
  >
    <div
      class="header-cell-face"
      :class="{
        'open': open
      }"
    >
    <template v-if="!isImageColumn">
      <label
        class="header-cell-label"
        v-text="display"
        :title="display"
      />
    </template>
    <template v-else>
      <img  :src="require('../../../assets/img/doc_icons/' + getColumnHeaderImage(item.FieldName))" alt="''"/>
    </template>

      <div
        class="header-cell-filter-dot"
        :class="{
          'active': showDot
        }"
      />
      <p4a-icon
        class="header-cell-filter-icon"
        :icon="'select'"
        :fill="'#212121'"
        :style="{
          'transform': 'rotate(0.5turn)'
        }"
        :stroke="null"
        :id="'svgIcon'"
      ></p4a-icon>
    </div>
  </div>
  <criteria-checklist
      v-if="hasFilters"
      v-show="open"
      :max-height="200"
      :item="item"
      :facet-options="options"
      :resultFromSearch="resultFromSearch"
      @addFilter="addFilter"
      @removeFilter="removeFilter"
      @filterActive="showFilterDot"
    />
  </div>
</template>

<script>
import * as _ from 'lodash'

import CriteriaCheckList from '../Criteria/content/CriteriaCheckList'
import * as folderApi from 'api/folderApi.js'
import mixins from 'mixins'

export default {
  name: 'HeaderCell',
  components: {
    'criteria-checklist': CriteriaCheckList
  },
  mixins: [mixins],
  data () {
    return {
      isDragged: false,
      movementX: 0,
      dragRefCounter: 0,
      draggedOn: false,
      open: false,
      currentOptions: null,
      showDot: false,
      dataReload: false
    }
  },
  props: {
    item: {
      default: function () {
        return {}
      },
      type: Object
    },
    folderId: {
      default: -1,
      type: Number
    },
    criteriaData: {
      default: function () {
        return {
          staticCriteria: [],
          dynamicCriteria: [],
          specificStaticCriteria: [],
          specificDynamicCriteria: []
        }
      },
      type: Object
    },
    selectionKey: {
      default: '',
      type: String
    },
    property: {
      default: '',
      type: String
    },
    cellWidth: {
      default: 20,
      type: Number
    },
    resultFromSearch: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    display () {
      let self = this
      return self.property
    },
    isImageColumn () {
      return this.property === '' && this.getColumnHeaderImage(this.item.FieldName) != null
    },
    hasOptions () {
      let self = this
      return _.size(self.currentOptions) > 0
    },
    options () {
      return this.currentOptions
    },
    hasFilters () {
      return this.item.Caption !== '' && this.item.FieldName !== 'CurrentShowingTime'
    }
  },
  methods: {
    clicked () {
      let self = this
      let openFacet = new Promise((resolve, reject) => {
        if (!self.open && self.hasFilters) {
          if (self.currentOptions === null || self.dataReload) {
            let filters = this.$store.getters.getAppliedCriteria
            self.open = true
            folderApi.requestFacetValues(self.folderId, self.item.FieldName, filters).then(result => {
              if (result !== null && result !== undefined) {
                self.currentOptions = self.processFacetValues(result)
                self.dataReload = false
                self.open = false
              }
              return resolve()
            })
          } else {
            return resolve()
          }
        } else {
          return resolve()
        }
      })
      openFacet.then(() => {
        self.open = !self.open
        self.$emit('clicked')
      })
    },
    filterOptionsRequested () {
      let self = this
      if (self.currentOptions === null || self.dataReload) {
        let filters = this.$store.getters.getAppliedCriteria
        folderApi.requestFacetValues(self.folderId, self.item.FieldName, filters).then(result => {
          if (result !== null && result !== undefined) {
            self.currentOptions = self.processFacetValues(result)
            self.dataReload = false
          }
        }).catch(error => console.log(error))
      }
    },
    addFilter (item) {
      this.$store.commit('addCriterion', item)
    },
    removeFilter (item) {
      this.$store.commit('deleteCriterion', item)
    },
    processFacetValues (data) {
      let self = this
      let facetValues = []
      let key = 0
      data.forEach(item => {
        let valueKey = 'Value'
        let hash = self.generateHash(`${self.item.Caption}${item[valueKey]}${self.item.FieldName}`)
        let selected = self.$store.getters.getCriterionFromCriteriaList(hash)
        facetValues.push({
          key: key++,
          Selected: selected,
          Value: item[valueKey],
          Visible: false,
          Filtered: false
        })
      })
      return facetValues
    },
    showFilterDot (showDot) {
      this.showDot = showDot
    }
  },
  created () {
    let self = this
    this.$eventBus.$on('applyFilters', () => {
      self.dataReload = true
      self.open = false
    })
  }
}
</script>

<style lang="scss" scoped>
  /*@import "~ui.kit.styling";*/
  @import '../../../kit-components/uikit';
  @import '../../../kit-components/styling/definitions';

  .hidden-div {
    height: 350px;
    width: 100%;
    position: relative;
    top: 0;
    left: 0;
    pointer-events: none;
  }
  .drag-button-texture{
    pointer-events: none;
    height: 16px;
    margin-top: 3px;
    float: right;
  }

  .header-cell-label {
    color: $darkGreyFont;
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: 500;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .indicator {
    z-index: 1;
    width: 1px;
    background: $pendingBlue;
    position: relative;
    top: -100%;
    height: 100vh;
  }

  .header-cell {
    display: inline-block;
    cursor: move;
    padding-top: 2px;
    width: 100%;
    height: 100%;
    top: 0;

    &-face {
      position: relative;
      display: inline-flex;
      height: 16px;
      font-size: 0;
      max-width: calc(100%);
      cursor: pointer;
    }

    &-label {
      display: inline;
      white-space: nowrap;
      height: 16px;
      margin: 0 0 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      line-height: 16px;
      color: $darkGreyFont;
      cursor: pointer;
      max-width: calc(100% - 30px);

      -webkit-transition: max-width 0.3s ease-in-out;
      -moz-transition: max-width 0.3s ease-in-out;
      transition: max-width 0.3s ease-in-out;

      &.short {
        max-width: calc(100% - 35px);
      }
    }

    &-filter-dot {
      display: inline;
      height: 5px;
      width: 0;
      border-radius: 50%;
      overflow: hidden;
      margin: 5px;
      background-color: $pendingBlue;
      opacity: 0;

      -webkit-transition: opacity 0.3s ease-in-out, width 0.3s ease-in-out;
      -moz-transition: opacity 0.3s ease-in-out, width 0.3s ease-in-out;
      transition: opacity 0.3s ease-in-out, width 0.3s ease-in-out;

      &.active {
        margin: 5px;
        width: 5px;
        opacity: 1;
      }
    }

    &-filter-icon {
      display: inline-block;
      height: 10px;
      width: 10px;
      transform: rotate(0.25turn);
      margin: 3px 0;
    }

  }

</style>



// WEBPACK FOOTER //
// src/components/grid/Cells/HeaderCell.vue